const initState = {
  uid: "",
  requested: false,
  registered: false,
  user: null,
  colorLoading: false,
  loading: false,
  userPermissions: null,
  forgetLoading: false,
};
const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        uid: action.user?.id,
        user: { ...action.user },
      };
    case "COLOR_LOADER":
      return {
        ...state,
        colorLoading: action.payload,
      };
    case "CATALOG_LOADER":
      return {
        ...state,
        loading: action.payload,
      };
    case "PERMISSIONS":
      return {
        ...state,
        userPermissions: action.payload,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        uid: "",
        registered: false,
        user: null,
      };
    case "LOGIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "LOGIN_REQUEST_END":
      return {
        ...state,
        loading: false,
      };
    case "FORGET_LOADER":
      return {
        ...state,
        forgetLoading: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: {
          ...state.user,
          name: action.payload.name,
          email: action.payload.email,
          description: action.payload.description,
          location: action.payload.location,
        },
      };
    case "UPDATE_PAYMENT_METHOD_DETAILS_SUCCESS_PAYPAL":
      return {
        ...state,
        user: {
          ...state.user,
          paypalSecretKey: action.payload.paypalSecretKey,
          paypalClientKey: action.payload.paypalClientKey,
        },
      };
    case "UPDATE_PAYMENT_METHOD_DETAILS_SUCCESS_STRIPE":
      return {
        ...state,
        user: {
          ...state.user,
          stripeSecretKey: action.payload.stripeSecretKey,
          stripeClientKey: action.payload.stripeClientKey,
        },
      };
    case "UPDATE_SOCIAL_PROFILE_LINKS":
      return {
        ...state,
        user: {
          ...state.user,
          socialProfiles: state.user.socialProfiles.map((profile) =>
            profile.type === action.payload.type
              ? { ...profile, url: action.payload.url }
              : profile
          ),
        },
      };
    case "UPDATE_RESTAURANT_TIP":
      return {
        ...state,
        user: {
          ...state.user,
          percentages: action.payload.percentages,
        },
      };
    case "UPDATE_RESTAURANT_LANGUAGE":
      return {
        ...state,
        user: {
          ...state.user,
          languages: action.payload.languages,
        },
      };
    case "UPDATE_SUBSCRIPTION_STATUS":
      return {
        ...state,
        user: {
          ...state.user,
          subScriptionStatus: action.payload,
        },
      };
    case "ADD_DELIVERY_DAYS":
      return {
        ...state,
        user: {
          ...state.user,
          deliveryDays: action.payload,
        },
      };
    case "ADD_PICKUP_DAYS":
      return {
        ...state,
        user: {
          ...state.user,
          pickupDays: action.payload,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default authReducer;
